var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5278 6.875C22.4487 6.875 23.3318 6.51284 23.983 5.86818C24.6342 5.22352 25 4.34918 25 3.4375C25 2.52582 24.6342 1.65148 23.983 1.00682C23.3318 0.362164 22.4487 0 21.5278 0C20.6069 0 19.7237 0.362164 19.0725 1.00682C18.4214 1.65148 18.0556 2.52582 18.0556 3.4375C18.0556 4.34918 18.4214 5.22352 19.0725 5.86818C19.7237 6.51284 20.6069 6.875 21.5278 6.875ZM22.2222 16.5V8.20273C21.9965 8.23281 21.7622 8.25 21.5278 8.25C20.5512 8.25 19.6398 7.96641 18.8802 7.47227L12.6519 12.534C11.7535 13.2645 10.4644 13.2645 9.56597 12.534L2.08333 6.44961V5.5C2.08333 5.12187 2.39583 4.8125 2.77778 4.8125H16.8663C16.7361 4.37852 16.6667 3.91445 16.6667 3.4375C16.6667 3.20547 16.684 2.97344 16.7144 2.75H2.77778C1.24566 2.75 0 3.9832 0 5.5V16.5C0 18.0168 1.24566 19.25 2.77778 19.25H19.4444C20.9766 19.25 22.2222 18.0168 22.2222 16.5ZM2.08333 9.11797L8.24653 14.1281C9.91319 15.4816 12.3134 15.4816 13.9757 14.1281L20.1389 9.11797V16.5C20.1389 16.8781 19.8264 17.1875 19.4444 17.1875H2.77778C2.39583 17.1875 2.08333 16.8781 2.08333 16.5V9.11797Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.07063c46182d7a85a7674a69abe224e9.svg";
export { ForwardRef as ReactComponent };